import { jsx as o } from "react/jsx-runtime";
import { memo as a, useMemo as s } from "react";
import { u as p } from "../../../styled-components.browser.esm-BFmoFexH.js";
import { Button as l } from "antd";
import u from "../../../FormFooter.js";
import { useLanguageResolver as c } from "@biron-data/react-contexts";
import { useSelectorLayout as d } from "../../../layout/useSelectorLayout.js";
const S = a(function({
  onSave: r,
  onCancel: e,
  onReset: i
}) {
  const m = c(), t = d(), n = s(() => t === "compact" ? "small" : "middle", [t]);
  return /* @__PURE__ */ o(f, { children: /* @__PURE__ */ o(u, { altDefault: /* @__PURE__ */ o(l, { type: "primary", danger: !0, onClick: i, size: n, children: m.get("button-reset") }, 2), cancel: e, submitting: !1, submit: r, hasHelp: !1, hasMargin: !0 }) });
}), f = p.div`
    border-top: 1px solid var(--main-background-color);
    padding-top: 13px;
    padding-bottom: 13px;
`;
export {
  S as default
};
//# sourceMappingURL=MetricOptionsFormFooter.js.map
